import gql from 'graphql-tag'

export const GET_ORGANISATION_TITLES = gql`
  query OrganisationTitles($organisationId: String, $category: String) {
    organisationTitles(organisationId: $organisationId, category: $category) {
      id
      description
      organisationId
      category
      title
    }
  }
`

export const GET_ORGANISATION_KEYWORDS = gql`
  query OrganisationKeywords($organisationId: String!) {
    organisationKeywords(organisationId: $organisationId) {
      id
      organisationId
      value
      key
    }
  }
`

export const GET_ORGANISATION_FEATURES = gql`
  query OrganisationFeatures($organisationId: String!) {
    organisationFeatures(organisationId: $organisationId) {
      id
      organisationId
      key
      module
      type
      status
    }
  }
`
